import { ExpandableCard } from "collections/Cards";
import { ServiceInformationTable } from "./ServiceInformationTable";
import React from "react";
import { useTranslation } from "utilities/i18n";
import { useDeviceLinesQuery } from "generated/graphql";
import { noLogoutOnAuthErrorContext } from "polygraphql";

export const ServiceInformation: React.FC<{ deviceId: string }> = ({
  deviceId
}) => {
  const { t } = useTranslation();
  const { data, fetching, stale } = useDeviceLinesQuery({
    variables: {
      deviceId
    },
    context: noLogoutOnAuthErrorContext
  });
  const exists =
    !fetching &&
    !stale &&
    (data?.capabilitiesQuery?.com?.poly?.service_information?.length ?? 0) > 0;
  return (
    <ExpandableCard
      collapsedContent={
        <div className={`category-title pl-5 ${exists ? "" : "mid-gray"}`}>
          {t("SERVICE_INFORMATION")}
        </div>
      }
      dropdown
      expanded
      disabled={!exists}
    >
      <ServiceInformationTable deviceId={deviceId} />
    </ExpandableCard>
  );
};
